/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  Timelock,
  TimelockInterface,
} from "../../../../contracts/mocks/governor/Timelock";

const _abi = [
  {
    inputs: [],
    name: "NotAuthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "CallExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "predecessor",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "delay",
        type: "uint256",
      },
    ],
    name: "CallScheduled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "Cancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldDuration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newDuration",
        type: "uint256",
      },
    ],
    name: "MinDelayChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "contract IDAOAccessControl",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "dao",
    outputs: [
      {
        internalType: "contract IDAO",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "datas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "predecessor",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "executeBatch",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "getMinDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "getTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "datas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "predecessor",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "hashOperationBatch",
    outputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_accessControl",
        type: "address",
      },
      {
        internalType: "address",
        name: "_dao",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_minDelay",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "isOperation",
    outputs: [
      {
        internalType: "bool",
        name: "pending",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "isOperationDone",
    outputs: [
      {
        internalType: "bool",
        name: "done",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "isOperationPending",
    outputs: [
      {
        internalType: "bool",
        name: "pending",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "isOperationReady",
    outputs: [
      {
        internalType: "bool",
        name: "ready",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "moduleFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "datas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "predecessor",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "delay",
        type: "uint256",
      },
    ],
    name: "scheduleBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newDelay",
        type: "uint256",
      },
    ],
    name: "updateDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type TimelockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TimelockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Timelock__factory extends ContractFactory {
  constructor(...args: TimelockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Timelock> {
    return super.deploy(overrides || {}) as Promise<Timelock>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Timelock {
    return super.attach(address) as Timelock;
  }
  override connect(signer: Signer): Timelock__factory {
    return super.connect(signer) as Timelock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TimelockInterface {
    return new utils.Interface(_abi) as TimelockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Timelock {
    return new Contract(address, _abi, signerOrProvider) as Timelock;
  }
}
